// components/CustomSelectWithMovingPlaceholder.tsx
'use client'

interface FloatingSelectProps {
  label: string          // always visible above
  name: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  options: { value: string; label: string }[]
  placeholder: string
  lessGap?: boolean
}

export default function FloatingSelect({
  label,
  name,
  value,
  onChange,
  options,
  placeholder,
  lessGap,
}: FloatingSelectProps) {
  const isSelected = value !== ''

  return (
    <div className={`${lessGap ? "" : "md:space-y-7 space-y-5"} w-full`}>
      {/* Permanent label always above */}
      <label 
        htmlFor={name}
        className="block text-base text-[#1B365E]"
      >
        {label}
      </label>

      <div className="relative group">
        <select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          className={`
            w-full px-4 
            bg-white  border border-[#EFEFEF] rounded-lg
            text-gray-900 cursor-pointer h-10
            focus:outline-none focus:placeholder:text-[#40BFDE] focus:ring-0 focus:border-[#40BFDE]
            appearance-none text-xs
            transition-all duration-200
            ${isSelected 
              ? 'pt-3 pb-1' 
              : 'py-3 text-[#ABABAB]!'
            }
          `}
        >
          <option value="" disabled hidden>
            {placeholder}
          </option>
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        {/* Moving & shrinking placeholder when selected */}
        {isSelected && (
          <span 
            className={`
              absolute left-3 top-1.25 
              px-1 bg-white text-[8px] font-medium text-gray-600
              pointer-events-none group-focus-within:text-[#40BFDE] group-focus-within:font-semibold
              transition-all duration-200
            `}
          >
            {placeholder}
          </span>
        )}

        {/* Dropdown arrow */}
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-600">
          <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.93713 11.6566C7.5449 12.2793 6.63705 12.2793 6.24482 11.6565L1.91557 4.78294C1.49615 4.11702 1.97473 3.25 2.76173 3.25L11.4202 3.25C12.2072 3.25 12.6858 4.11702 12.2664 4.78294L7.93713 11.6566Z" fill="#1B365E"/>
          </svg>
        </div>
      </div>
    </div>
  )
}